import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ListChecksIcon, ShoppingCartIcon, ChefHatIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
export function WhatsIncludedSection() {
  const items = [{
    icon: <BookOpenIcon className="h-6 w-6" data-id="element-243" />,
    text: "El sistema completo '3 Bases + 5 Variaciones'"
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6" data-id="element-244" />,
    text: 'Reglas de pérdida de grasa sin contar calorías'
  }, {
    icon: <ShoppingCartIcon className="h-6 w-6" data-id="element-245" />,
    text: 'Lista inteligente de compras (anti-antojos)'
  }, {
    icon: <ChefHatIcon className="h-6 w-6" data-id="element-246" />,
    text: 'Prep mínimo viable con airfryer + cocina'
  }, {
    icon: <ListChecksIcon className="h-6 w-6" data-id="element-247" />,
    text: '30 combinaciones Turbo listas'
  }, {
    icon: <FileTextIcon className="h-6 w-6" data-id="element-248" />,
    text: 'Plantillas imprimibles (menú, lista, inventario)'
  }];
  return <section className="w-full bg-[#111111] text-[#FAFAF7] py-24 px-4 sm:px-6" data-id="element-249">
      <div className="max-w-4xl mx-auto" data-id="element-250">
        <div className="text-center mb-16" data-id="element-251">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-252">
            Qué incluye exactamente
          </h2>
          <p className="text-xl text-gray-400" data-id="element-253">
            Todo lo que necesitas para dejar de improvisar.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-254">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-6 rounded-xl flex items-start gap-4 hover:bg-white/10 transition-colors" data-id="element-255">
              <div className="text-[#E8652D] bg-[#E8652D]/10 p-2 rounded-lg shrink-0" data-id="element-256">
                {item.icon}
              </div>
              <p className="font-medium text-lg" data-id="element-257">{item.text}</p>
            </motion.div>)}
        </div>

        {/* Plan B Mention */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-16 bg-[#1A1A1A] p-8 rounded-2xl border border-[#E8652D]/30 text-center" data-id="element-258">
          <h3 className="text-2xl font-bold mb-4" data-id="element-259">
            "Pero yo no soy constante..."
          </h3>
          <p className="text-lg text-gray-300 mb-6" data-id="element-260">
            Exacto. Por eso esto no depende de constancia perfecta. Incluye un{' '}
            <strong data-id="element-261">Plan B</strong> para semanas difíciles:
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-400" data-id="element-262">
            <span className="bg-black/30 px-3 py-1 rounded-full border border-white/10" data-id="element-263">
              Comidas salvavidas
            </span>
            <span className="bg-black/30 px-3 py-1 rounded-full border border-white/10" data-id="element-264">
              Reglas para comer fuera
            </span>
            <span className="bg-black/30 px-3 py-1 rounded-full border border-white/10" data-id="element-265">
              Volver al carril sin culpa
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}